export default __webpack_public_path__ + "cocoa_doorbell_v5_ac.7425c838.png";